import { Checkbox, FormControlLabel, Grid } from "@mui/material";
import React, { useState } from "react";
import { handleChangeHeader } from "../../../../../utils/commonFunctions/fieldCapitalize";
import { pink } from "@mui/material/colors";
import {
	firstFieldIDRTrackersList_v2,
	secondFieldIDRTrackersList_v2
} from "../../../../../constants/fieldsList/FieldsList";
import { IDRTrackersSelectColumnHeadersProps } from "../../../../../@types/appealReportAllprops.types";

const IDRTrackersSelectColumnHeaders: React.FC<IDRTrackersSelectColumnHeadersProps> = ({
	key,
	selectedColumns,
	handleUpdateSelectedColumns,
	appealsIDRTrackersCommonUnion,
	handleAppealsIDRTrackersCommonUnionChange
}) => {
	const [showIDRTrackers, setShowIDRTrackers] = useState(Boolean(appealsIDRTrackersCommonUnion.idrtrackers));

	const [union, setUnion] = useState<boolean | null>(
		appealsIDRTrackersCommonUnion.idrtrackers == "common"
			? false
			: appealsIDRTrackersCommonUnion.idrtrackers == "union"
			? true
			: null
	);

	const handleSetUnionCChange = () => {
		if (union) {
			handleAppealsIDRTrackersCommonUnionChange("idrtrackers", "common");
			setUnion(false);
		} else {
			handleAppealsIDRTrackersCommonUnionChange("idrtrackers", "union");
			setUnion(true);
		}
	};

	const handleShowIDRTracckersChange = () => {
		if (showIDRTrackers) {
			setUnion(null);
			handleAppealsIDRTrackersCommonUnionChange("idrtrackers", null);
			setShowIDRTrackers(false);
		} else {
			setUnion(true);
			handleAppealsIDRTrackersCommonUnionChange("idrtrackers", "union");
			setShowIDRTrackers(true);
		}
	};
	return (
		<div>
			<div
				style={{
					width: "100%",
					margin: "auto",
					textAlign: "center",
					fontWeight: "bolder",
					color: "#ab455c",
					fontSize: "20px",
					marginBottom: "20px"
				}}
			>
				IDR-Trackers
				<Checkbox
					checked={showIDRTrackers}
					sx={{
						color: pink[800],
						"&.Mui-checked": { color: pink[600] }
					}}
					onChange={(event: any) => handleShowIDRTracckersChange()}
				/>
			</div>
			{showIDRTrackers && (
				<div style={{ textAlign: "center", marginBottom: "20px" }}>
					<Grid item xs={12}>
						<FormControlLabel
							control={
								<Checkbox
									checked={union === true}
									onChange={(e: any) => handleSetUnionCChange()}
									sx={{
										color: pink[800],
										"&.Mui-checked": { color: pink[600] }
									}}
								/>
							}
							label="Union"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={union === false}
									onChange={(e: any) => handleSetUnionCChange()}
									sx={{
										color: pink[800],
										"&.Mui-checked": { color: pink[600] }
									}}
								/>
							}
							label="Common"
						/>
					</Grid>
				</div>
			)}
			{showIDRTrackers && (
				<div className="fieldContainer">
					<Grid container spacing={4}>
						{[firstFieldIDRTrackersList_v2, secondFieldIDRTrackersList_v2].map((fieldList, columnIndex) => (
							<Grid item xs={12} sm={12} md={6} key={columnIndex}>
								<Grid container style={{ marginBottom: "1rem", color: "#ab455c", fontWeight: "bold" }}>
									<Grid item xs={6}>
										FIELD NAME
									</Grid>
									<Grid item xs={6} style={{ textAlign: "center" }}>
										View
									</Grid>
								</Grid>
								{fieldList.map((field, index) => (
									<Grid container key={index} style={{ marginBottom: "1rem" }} alignItems="center">
										<Grid item xs={6}>
											{handleChangeHeader(field).replace("CHEQUE", "CHECK")}
										</Grid>
										<Grid item xs={6} style={{ textAlign: "center" }}>
											<Checkbox
												checked={selectedColumns.idrtrackers[field]}
												sx={{
													color: pink[800],
													"&.Mui-checked": { color: pink[600] }
												}}
												onChange={(event: any) =>
													handleUpdateSelectedColumns(
														field,
														event.target.checked,
														"idrtrackers"
													)
												}
											/>
										</Grid>
									</Grid>
								))}
							</Grid>
						))}
					</Grid>
				</div>
			)}
		</div>
	);
};

export default IDRTrackersSelectColumnHeaders;
